import { GuardFunctionRouteProps, GuardToRoute, Next } from 'react-router-guards/dist/types'

export const guardsRoutes = async (to:GuardToRoute, from:GuardFunctionRouteProps | null, next:Next) => {
  return next()
}
